const audioSplit = {
	AS_IS: "According to uploaded files",
	SPLIT: "Split by chapter points",
	CONCAT: "Concatenate to single file",
};

export default audioSplit;
